module.exports = __webpack_public_path__ + "img/pic2.6b7b2751.png";